import { OverlayRef } from '@angular/cdk/overlay';
import { InputSignal, WritableSignal } from '@angular/core';
import { IBbitI18n, IBbitSelectDataRow } from '@bbitgmbh/bbit.utils';
import { Observable, Subject } from 'rxjs';

export interface IComboboxOverlayData {
  values: WritableSignal<IBbitSelectDataRow[]>;
  noRowsText: InputSignal<IBbitI18n | undefined>;
  allowNewEntry: InputSignal<boolean>;
  newEntryText: InputSignal<IBbitI18n | undefined>;
}

export interface IComboboxResult {
  selected?: IBbitSelectDataRow;
  createNewEntry?: boolean;
}

export class ComboboxOverlayRef {
  private _data!: IComboboxOverlayData;
  private _onClose = new Subject<IComboboxResult | undefined>();
  private _selectCurrentSubject = new Subject<void>();
  private _selectNext = new Subject<void>();
  private _selectPrevious = new Subject<void>();
  public constructor(private _overlayRef: OverlayRef) {}

  public close(params?: IComboboxResult): void {
    this._overlayRef.dispose();
    this._onClose.next(params);
    this._onClose.complete();
  }

  public setData(data: IComboboxOverlayData): void {
    this._data = data;
  }

  public getData(): IComboboxOverlayData {
    return this._data;
  }

  public observeClose(): Observable<IComboboxResult | undefined> {
    return this._onClose.asObservable();
  }

  public selectCurrent(): void {
    this._selectCurrentSubject.next();
  }

  public observeSelectCurrent(): Observable<void> {
    return this._selectCurrentSubject.asObservable();
  }

  public selectNext(): void {
    this._selectNext.next();
  }

  public observeSelectNext(): Observable<void> {
    return this._selectNext.asObservable();
  }

  public selectPrevious(): void {
    this._selectPrevious.next();
  }

  public observeSelectPrevious(): Observable<void> {
    return this._selectPrevious.asObservable();
  }
}
